import React, { useEffect, useRef } from 'react';

export const ImportLogs = ({ logs }) => {
  const logsContainerRef = useRef(null);

  useEffect(() => {
    const scrollToBottom = () => {
      if (logsContainerRef.current) {
        logsContainerRef.current.scrollTo({
          top: logsContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    };

    // Small delay to ensure DOM has updated
    const timeoutId = setTimeout(scrollToBottom, 50);
    return () => clearTimeout(timeoutId);
  }, [logs]);

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h4 className="text-sm font-medium text-gray-900 mb-2">Import Logs</h4>
      <div 
        ref={logsContainerRef} 
        className="space-y-1 max-h-40 overflow-y-auto scroll-smooth"
      >
        {logs.map((log, index) => (
          <div
            key={index}
            className={`text-sm ${
              log.type === 'error'
                ? 'text-red-600'
                : log.type === 'warning'
                ? 'text-yellow-600'
                : 'text-gray-600'
            }`}
          >
            {log.message}
          </div>
        ))}
      </div>
    </div>
  );
};
